import EnumClass, { build } from '../EnumClass';
import data, { TeacherChangeReasonId, TeacherChangeReasonData } from './data';
import * as Translations from './translations';

export class TeacherChangeReason extends EnumClass<TeacherChangeReasonId, TeacherChangeReasonData> {
  public get getName() {
    return Translations.name[this.id];
  }
}

export const {
  list: TEACHER_CHANGE_REASONS,
  getById: getTeacherChangeReasonById,
  marshaller: TeacherChangeReasonMarshaller,
} = build<TeacherChangeReasonId, TeacherChangeReasonData, TeacherChangeReason>(
  'TeacherChangeReasonEnum',
  data,
  TeacherChangeReason,
);
